// src/components/reports/SummaryBox.jsx

import React from 'react';
import { PAGE } from '../ui';

export default function SummaryBox({ label, value }) {
  return (
    <div
      style={{
        minWidth: 100,
        background: '#eff6ff',
        border: `1px solid ${PAGE.colors.line}`,
        borderRadius: PAGE.radius.input,
        padding: '10px 12px',
      }}
    >
      <div
        style={{
          fontSize: 10,
          fontWeight: 900,
          color: PAGE.colors.muted,
          textTransform: 'uppercase',
          letterSpacing: 0.5,
          marginBottom: 4,
        }}
      >
        {label}
      </div>
      <div style={{ fontSize: 22, fontWeight: 800, color: PAGE.colors.navy, lineHeight: 1 }}>
        {value}
      </div>
    </div>
  );
}
